import React, { memo, useEffect, useState } from "react";

// Components
import BaseModal from "~/components/modals/BaseModal";
// Styles
import s from "~/components/modals/error/ErrorModal.module.scss";
// Utils
import { goToHelpPage } from "~/utils/helpers";

interface Props {
  isOpened: boolean;
  width?: number;
  onClose: () => void;
  onConfirm?: () => void;
  children?: React.ReactNode;
}

export const ErrorModal: React.FC<Props> = memo(
  ({
    isOpened = false,
    width = "510px",
    children,
    onClose,
    onConfirm = () => ({}),
  }) => {
    const [open, setOpen] = useState<boolean>(isOpened);

    useEffect(() => {
      setOpen(isOpened);
    }, [isOpened]);

    const handleConfirm = () => {
      goToHelpPage();
      onConfirm();
    };

    return (
      <BaseModal
        width={width}
        isOpened={open}
        onClose={onClose}
        onConfirm={handleConfirm}
        textClose="Закрыть"
        textConfirm="Рассказать о проблеме"
      >
        <div className={"headline-2 " + s.errorTitle}>
          <p>Ошибка</p>
        </div>
        {children}
      </BaseModal>
    );
  }
);

ErrorModal.displayName = "ErrorModal";

export default ErrorModal;
